import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4a6da7',
      },
      dark: {
        primary: '#4a6da7',
      },
    },
  },
});
